export const SAVE_ALL_MAINTENANCE_SCHEDULINGS =
  'SAVE_ALL_MAINTENANCE_SCHEDULINGS'
export const SAVE_MAINTENANCE_SCHEDULING = 'SAVE_MAINTENANCE_SCHEDULING'
